import React, {Component} from 'react';
import {Grid, Row, Col, FormControl, Form, FormGroup, ControlLabel} from "react-bootstrap";
import {TopAlertUwaga} from "../../componentsTopsa/alerty/TopAlerts";
import TopIf from "../../componentsTopsa/if/TopIf";
import LogowanieService from "./LogowanieService";
import AppConfig from "../../AppConfig";
import loga from '../../images/logotypywszystkie.png'

export default class LogowanieContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            login: '',
            pass: '',
            error: false,
        };
        this.onClickZaloguj = this.onClickZaloguj.bind(this)
        this.onChangeLogin = this.onChangeLogin.bind(this)
        this.onChangePass = this.onChangePass.bind(this)
        this._handleKeyPress = this._handleKeyPress.bind(this)
    }


    onChangeLogin(e) {
        this.setState({login: e.target.value})
    }

    onChangePass(e) {
        this.setState({pass: e.target.value})
    }

    onClickZaloguj() {

        this.setState({error: false})

        if (Boolean(this.state.login) && Boolean(this.state.pass)) {

            LogowanieService.wyslijZapytanieOLogowanie(this.state.login, this.state.pass).then(response => {
                if (response) {
                    if (response.status < 300) {
                        this.setState({error: 'Zalogowano pomyślnie'})
                        let user = response.data.uzytk
                        let token = {token: 'Basic ' + btoa(this.state.login + ':' + this.state.pass)}
                        let imnaz = {imieNazwisko:response.data.uzytkTypDane.imie+' '+response.data.uzytkTypDane.nazwisko}

                        user = Object.assign(user,token)
                        user = Object.assign(user,imnaz)

                        LogowanieService.zalogujUzytkownika(user, 'Basic ' + btoa(this.state.login + ':' + this.state.pass))
                        this.props.history.push('/')
                    }
                }

            })
                .catch(err => {
                    console.error(err);
                    this.setState({error: 'Proszę spróbować ponownie'})
                })

        }
        else {
            this.setState({error: 'Proszę uzupełnić pola'})
        }

    }

    _handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.onClickZaloguj();
        }
    }

    render() {

        return (
            <div id={"LogowaniePage"}>
                <Grid fluid={true}>
                    <Row>
                        <Col xs={12} lg={4} lgOffset={4}>
                            <Col xs={12} lg={10} lgOffset={1}>
                                <div id={'logowanie-form'}>
                                    <Row>
                                        <Col xs={12}>
                                            <div style={{textAlign: 'center'}} className={'logo-ebus'}>
                                                <h1>TOP eBus</h1>
                                                <span style={{
                                                    fontSize: '12px',
                                                    color: 'grey'
                                                }}>
                                                    {AppConfig.APP_VER() + ' ' + AppConfig.APP_UPDATE()}</span></div>
                                        </Col>
                                    </Row>
                                    <Form horizontal={true}>
                                        <Col xs={12}>
                                            <FormGroup>
                                                <Col xs={12} lg={3}>
                                                    <ControlLabel>
                                                        <i className={'fa fa-user'}></i> Login:
                                                    </ControlLabel>
                                                </Col>
                                                <Col xs={12} lg={9}>
                                                    <FormControl onChange={this.onChangeLogin} onKeyPress={this._handleKeyPress} autoFocus/>
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12}>
                                            <FormGroup>
                                                <Col xs={12} lg={3}>
                                                    <ControlLabel>
                                                        <i className={'fa fa-lock'}></i> Hasło:
                                                    </ControlLabel>
                                                </Col>
                                                <Col xs={12} lg={9}>
                                                    <FormControl onChange={this.onChangePass} type={"password"} onKeyPress={this._handleKeyPress}/>
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12}>
                                            <Row>
                                                <Col xs={12}>
                                                    <div style={{textAlign: 'center'}}>
                                                        <a onClick={this.onClickZaloguj} className={'btn btn-primary btn-ebus-zaloguj'}>
                                                            <i className={'fa fa-sign-in'}></i> Zaloguj się
                                                        </a>
                                                        <TopIf isTrue={Boolean(this.state.error)}>
                                                            <div id={'errorMsg'}>
                                                                <TopAlertUwaga text={this.state.error}/>
                                                            </div>
                                                        </TopIf>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <div style={{clear: 'both', height: '1px'}}></div>
                                    </Form>
                                </div>
                            </Col>
                            <Col xs={12}>
                                <div style={{marginTop:'25px'}}>
                                    <div>
                                        <img src={loga} className={'img-responsive'} />
                                    </div>
                                    <div style={{fontSize:'12px', color:'#444',marginTop:'15px',fontStyle:'italic',textAlign:'center'}}>
                                        Projekt współfinansowany z Europejskiego Funduszu Rozwoju Regionalnego w ramach poddziałania 1.4.1 Regionalnego Programu Operacyjnego Województwa Podkarpackiego na lata 2014 – 2020.
                                    </div>
                                    <div style={{marginTop:'5px', fontSize:'10px', color:'grey',textAlign:'center'}}>
                                        Realizacja: TOP S.A. &copy; {new Date().toJSON().substr(0,4)}
                                    </div>
                                </div>
                            </Col>
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/logowanie/LogowanieContainer.js